/* =========================================================
   StreetKings Customs: shared header, menu and footer.
   Every page includes it right where each part goes:
     <script src="assets/layout.js" data-part="header"></script>
     <script src="assets/layout.js" data-part="footer"></script>
   Change the menu or footer here once and every page updates.
   ========================================================= */
(function(){
  const HEADER = `
<div class="announce">New: <a href="/products/2015-2023-dodge-charger-kingflow-rgb-pre-built-tail-lights">KingFlow RGB Tail Lights</a> for Charger and Challenger</div>

<header class="header">
  <div class="header-inner">
    <button class="menu-btn icon-btn" aria-label="Menu"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 6h18M3 12h18M3 18h18"/></svg></button>
    <nav class="nav" aria-label="Main">
      <div class="nav-item">
        <button class="nav-top" type="button" aria-expanded="false">Shop by Car<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m6 9 6 6 6-6"/></svg></button>
        <div class="dropdown">
          <a href="/collections/all?car=charger">Charger <small>2015–2023</small></a>
          <a href="/collections/all?car=challenger">Challenger <small>2008–2023</small></a>
          <a href="/collections/all?car=300">Chrysler 300 <small>2011–2023</small></a>
          <a href="/collections/all?car=durango">Durango <small>2014–2023</small></a>
          <a href="/collections/all?car=cherokee">Cherokee <small>2010–2022</small></a>
          <a href="/collections/all?car=trx">Ram TRX <small>2021–2024</small></a>
          <a class="all" href="/#shop-by-car">See all cars</a>
        </div>
      </div>
      <div class="nav-item">
        <button class="nav-top" type="button" aria-expanded="false">Shop by Part<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m6 9 6 6 6-6"/></svg></button>
        <div class="dropdown">
          <a href="/collections/hoods">Hoods</a>
          <a href="/collections/lighting">Lighting</a>
          <a href="/collections/grill-badges">Grill Badges</a>
          <a href="/collections/skc-performance">Wheels <small>SKC Performance</small></a>
          <a href="/collections/body-aero">Body &amp; Aero</a>
          <a href="/products/classic-black-rgb-srt-airbag-cover">Interior</a>
          <a class="all" href="/collections/all">Shop all parts</a>
        </div>
      </div>
      <div class="nav-item">
        <button class="nav-top" type="button" aria-expanded="false">Flow Series<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"><path d="m6 9 6 6 6-6"/></svg></button>
        <div class="dropdown">
          <a href="/collections/grill-badges">Grill Badges <small>17 styles</small></a>
          <a href="/collections/lighting">Headlights &amp; Tail Lights</a>
          <a href="/products/classic-black-rgb-srt-airbag-cover">RGB Airbag Cover</a>
          <a href="/products/wiring-kit-flowseries-badge">Replacement Wiring Kit</a>
          <a class="all" href="/collections/flow-series">Shop the Flow Series</a>
        </div>
      </div>
      <a class="nav-top nav-skc" href="/#skc" aria-label="SKC Performance"><img src="${SKA}skc-performance-black.png" alt="SKC Performance" width="1279" height="64"></a>
    </nav>
    <a class="logo" href="/"><b>STREETKINGS</b><span>CUSTOMS</span></a>
    <div class="tools">
      <a class="pill" href="/#build">Build Your Car</a>
      <a class="icon-btn hide-sm" href="/search" aria-label="Search"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.5-3.5"/></svg></a>
      <a class="icon-btn" href="/cart" aria-label="Cart"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 4h2l2.4 11.2a1 1 0 0 0 1 .8h9.2a1 1 0 0 0 1-.8L20 8H6"/><circle cx="9" cy="20" r="1.3"/><circle cx="17" cy="20" r="1.3"/></svg></a>
      <a class="icon-btn hide-sm" href="/account" aria-label="Account"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="10" r="3.2"/><path d="M6.2 18.4a6.5 6.5 0 0 1 11.6 0"/></svg></a>
    </div>
  </div>
</header>
`;

  const FOOTER = `
<footer class="footer">
  <div class="footer-inner">
    <div class="footer-brand">
      <a class="logo" href="/"><b>STREETKINGS</b><span>CUSTOMS</span></a>
      <p>Custom parts and RGB lighting for the Charger, Challenger, Chrysler 300, Durango, Cherokee and Ram TRX.</p>
      <a class="footer-mail" href="mailto:info@streetkingscustoms.shop">info@streetkingscustoms.shop</a>
      <div class="socials">
        <a href="https://www.instagram.com/streetkingscustoms/" target="_blank" rel="noopener" aria-label="StreetKings on Instagram"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor"/></svg></a>
        <a href="https://www.tiktok.com/@streetkingscustoms" target="_blank" rel="noopener" aria-label="StreetKings on TikTok"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M16.6 3c.3 2.3 1.6 3.8 3.9 4v2.9a7.4 7.4 0 0 1-3.8-1.1v6.4A5.8 5.8 0 1 1 10.9 9.4v3a2.9 2.9 0 1 0 2.9 2.9V3h2.8z"/></svg></a>
      </div>
      <a class="btn-rgb" href="/#build">Build your car</a>
    </div>
    <div>
      <h3>Shop by car</h3>
      <a href="/collections/all?car=charger">Charger</a>
      <a href="/collections/all?car=challenger">Challenger</a>
      <a href="/collections/all?car=300">Chrysler 300</a>
      <a href="/collections/all?car=durango">Durango</a>
      <a href="/collections/all?car=cherokee">Cherokee</a>
      <a href="/collections/all?car=trx">Ram TRX</a>
    </div>
    <div>
      <h3>Shop by part</h3>
      <a href="/collections/hoods">Hoods</a>
      <a href="/collections/lighting">Lighting</a>
      <a href="/collections/grill-badges">Grill Badges</a>
      <a href="/collections/skc-performance">SKC Performance Wheels</a>
      <a href="/collections/body-aero">Body &amp; Aero</a>
      <a href="/collections/flow-series">Flow Series</a>
    </div>
    <div>
      <h3>Help</h3>
      <a href="/pages/faq">FAQ</a>
      <a href="/pages/contact">Contact us</a>
      <a href="/account">Track my order</a>
      <a href="/policies/shipping-policy">Shipping</a>
      <a href="/policies/refund-policy">Returns</a>
      <a href="/policies/privacy-policy">Privacy</a>
      <a href="/policies/terms-of-service">Terms</a>
    </div>
  </div>
  <div class="footer-bottom">© <span id="year">2026</span> StreetKings Customs</div>
</footer>
`;

  const me = document.currentScript, part = me && me.dataset.part;

  if(part === "header"){
    me.insertAdjacentHTML("beforebegin", HEADER);
    const header = document.querySelector(".header");
    // phone menu
    header.querySelector(".menu-btn").onclick = e => e.currentTarget.setAttribute("aria-expanded", header.classList.toggle("open"));
    header.querySelectorAll(".nav a").forEach(a => a.addEventListener("click", () => header.classList.remove("open")));
    // dropdowns: hover on desktop, tap to open on touch screens
    header.querySelectorAll(".nav-item > .nav-top").forEach(btn => btn.addEventListener("click", e => {
      const item = btn.parentElement, open = !item.classList.contains("open");
      header.querySelectorAll(".nav-item.open").forEach(i => { i.classList.remove("open"); i.firstElementChild.setAttribute("aria-expanded","false"); });
      item.classList.toggle("open", open); btn.setAttribute("aria-expanded", open);
      e.stopPropagation();
    }));
    document.addEventListener("click", e => { if(!e.target.closest(".nav-item")) header.querySelectorAll(".nav-item.open").forEach(i => i.classList.remove("open")); });
  }

  if(part === "footer"){
    me.insertAdjacentHTML("beforebegin", FOOTER);
    const y = document.getElementById("year");
    if(y) y.textContent = new Date().getFullYear();
  }
})();
